import { renderDate } from '../utility/personTabGridHelper';

export const HISTORY_COLUMNS = [
  { field: 'Updated', headerName: 'Date', minWidth: 190, flex: 1, valueFormatter: renderDate },
  { field: 'UpdatedBy', headerName: 'By', minWidth: 180, flex: 1 },
  { field: 'RaceDescription', headerName: 'Race', minWidth: 110, flex: 0.7 },
  { field: 'SexDescription', headerName: 'Sex', minWidth: 100, flex: 0.6 },
  { field: 'Height', headerName: 'Height', minWidth: 110, flex: 0.7 },
  { field: 'Weight', headerName: 'Weight', minWidth: 110, flex: 0.7 },
  { field: 'HairColorDescription', headerName: 'Hair', minWidth: 110, flex: 0.7 },
  { field: 'EyeColorDescription', headerName: 'Eyes', minWidth: 110, flex: 0.7 },
].map((column) => ({ ...column, sortable: false, filterable: false }));
